export const types = {
  inventarioinicialSetActive:
    "[inventarioinicial] inventario inicial Set Active",
  inventarioinicialLoaded: "[inventarioinicial] inventario inicial Loaded",
  inventarioinicialClearActive:
    "[inventarioinicial] inventario inicial Clear Active",
  inventarioinicialAdded: "[inventarioinicial] inventario inicial added",
  inventarioinicialUpdated: "[inventarioinicial] inventario inicial updated",
  inventarioinicialDeleted: "[inventarioinicial] inventario inicial deleted",
  inventarioinicialLogout: "[inventarioinicial]inventario iniciale logout",
  inventarioinicialLoading:
    "[inventarioinicial] inventario inicial set loading",
};
